import { TRESPONSE_MACHINE_SERVICE_LIST } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';

export const MACHINE_SERVICE_LIST_TABLE_MODEL = {
  createModel: (items: TRESPONSE_MACHINE_SERVICE_LIST['maintenanceSchedules']) => {
    return ModifiersZTableModel.createTableModel(
      items,
      {
        padding: 8,
        select: {
          position: 'START',
          isMulti: true,
          size: 'DEFAULT',
        },
        headerConfig: [
          {
            type: 'TEXT_CELL',
            text: 'table_model.MACHINETYPE',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.MACHINECATEGORY',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.MACHINESUB-CATEGORY',
          },
          {
            type: 'TEXT_CELL',
            text: 'table_model.CHECKLISTTOFOLLOW',
          },
          {
            type: 'TEXT_CELL',
            text: '',
            widthInPx: 32,
          },
          {
            type: 'TEXT_CELL',
            text: '',
            widthInPx: 32,
          },
        ],
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          isSelected: false,
          cells: [
            {
              type: 'TEXT_CELL',
              text: item.machineType,
            },
            {
              type: 'TEXT_CELL',
              text: item.machineCategory,
            },
            {
              type: 'TEXT_CELL',
              text: item.machineSubCategory || '--',
            },

            {
              type: 'TEXT_CELL',
              text: item.serviceTasks.length
                ? item.serviceTasks.length > 1
                  ? item.serviceTasks[0] + '...'
                  : item.serviceTasks[0]
                : '--',
            },
            {
              type: 'ACTION_CELL',
              actionType: 'VIEW',
              asIcon: true,
            },
            {
              type: 'ACTION_CELL',
              actionType: 'EDIT',
              asIcon: true,
            },
          ],
        };
      },
    );
  },
};
